import { useMutation } from "@tanstack/react-query";

import { startDocumentUpload } from "@/adapters/api";
import type { UploadBatchOptions } from "../utils/upload-queue.ts";

export interface StartUploadInput extends UploadBatchOptions {
	file: File;
}

export function useStartUpload(constructionId: string | undefined) {
	return useMutation({
		mutationFn: async ({ file, category, clientVisible }: StartUploadInput) => {
			if (!constructionId) throw new Error("missing construction");
			const { document, upload } = await startDocumentUpload(constructionId, {
				fileName: file.name,
				sizeBytes: file.size,
				category,
				clientVisible,
			});
			return { documentId: document.id, grant: upload };
		},
	});
}
